import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import consumer from "../channels/consumer"
import escape from "lodash.escape";
import MarkdownIt from "markdown-it";

export default class extends Controller {
  static values = {
    id: Number
  }

  connect() {
    this.messages = []
    this.lastProcessedMessage = -1
    this.fullResponse = ""
    this.md = new MarkdownIt({
      html: true,        // Enable HTML tags in source
      breaks: false,     // Don't convert single \n to <br>
      linkify: true,     // Autoconvert URL-like text to links
      typographer: true  // Enable some language-neutral replacement + quotes beautification
    })
    this.subscription = consumer.subscriptions.create(
      { channel: "OpenaiChatMessageChannel", id: this.idValue },
      {
        connected: () => {
          this.messagesWrapper = $('#chat-messages')[0];
        },
        received: (data) => {
          switch (data.type) {
            case "message_chunk":
              this.processMessage(data)
              break
            case "message_finished":
              this.messageFinished()
              break
          }
        }
      }
    )
  }

  // guarantee correct order of messages
  processMessage(message) {
    this.messages = [...this.messages, message].sort((a, b) => (a.serial - b.serial))

    while (this.messages.length) {
      if (this.messages[0].serial == this.lastProcessedMessage + 1) {
        const message = this.messages.shift()
        this.fullResponse += message.chunk
        // Process the entire accumulated response with markdown-it
        const processedContent = this.md.render(this.fullResponse)
        this.element.innerHTML = processedContent
        this.lastProcessedMessage = message.serial;
        if (this.messagesWrapper.scrollHeight - (this.messagesWrapper.scrollTop + this.messagesWrapper.clientHeight) < 50) {
          this.messagesWrapper.scrollTop = this.messagesWrapper.scrollHeight;
        }
      } else {
        break;
      }
    }
  }

  messageFinished() {
    setTimeout(() => {
      this.subscription.unsubscribe()
      consumer.disconnect();
      $('#chat-typing').remove()
      $('#openai_chat_message_input').attr('disabled', false)
      $('#openai_chat_message_input').trigger('focus')
      $('#new_openai_chat_message input[type="submit"]').attr('disabled', false)
      // Reset the full response for the next message
      this.fullResponse = ""
    }, 300)
  }

  populateData(data) {
    this.streetInputTarget.value = data.logradouro;
    this.neighborhoodInputTarget.value = data.bairro;
    this.cityInputTarget.value = data.localidade;
    this.stateInputTarget.value = data.uf;
  }
}
